import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.css'],
   providers: [HelperService] 
})
export class PermissionsComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas:any=[];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;

  icon=this.helper.add_icon;
  icon_action='addClick';
  perm_name='';
  perm_id=0;
  perm_slug;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private router: Router,private cookie:CookieService) {
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.datas = JSON.parse(data['_body']);
      
        this.dtTrigger.next();
     
    });
  }

  editClick(data){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.perm_name=data.name;
    this.perm_id=data.id;
    this.perm_slug=data.slug;
  }
  addClick(e){
    
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  add_form(addForm: NgForm){
  	//console.log(addForm.value);
  let body = new FormData();
  body.append('name', addForm.value.name);
  body.append('slug', addForm.value.slug);
  
   this.http.post(this.helper.base_url+'http/add/permission', body,{ headers: this.headers })
   .subscribe(
     (res) => {
        let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'Permission added successfully') ;
    }else{
       this.listClick(null) ;
      this.error_refresh(false,data.message) ;
    }
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 update_form(addForm: NgForm){
  let body = new FormData();
  body.append('name', addForm.value.name);
 // body.append('slug', addForm.value.slug);
   this.http.post(this.helper.base_url+'http/update/permission/'+this.perm_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
          let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'Permission updated successfully') ;
    }else{
       //this.listClick(null) ;
      //this.error_refresh(false,data.message) ;
      this.snackbar.open(data.message, null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
    }
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 delete_form(id){
          
  let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 3000,
      extraClasses:  ['warning-snackbar'],
    }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/delete/permission/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => this.refresh(false,'Permission Removed successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
   
  }
  refresh(val=false,msg){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/permissions"]));
  
      
 }
 error_refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/permissions"]));
  
      
 }

}



// WEBPACK FOOTER //
// ./src/app/permissions/permissions.component.ts